import React, { useState } from "react";
import Swal from "sweetalert2";
import "./DataTableComponent.css";

function DataTableComponent({
  title,
  columns = [],
  columnsMapping = [],
  keyField,
  data = [],
  handleEdit,
  openAssignModal,
  openHistory,
  exportReleve,
  handleDetail,
  handleDelete,
  handleExport,
  handleExportPdf,
  handlePrintPdf,
  handleValidate,
  handleUnvalidate,
  handleExportWord,
  handleExportExcel,
  handleShowReglements,
  handleShowLivraisons,
}) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const rowsPerPage = 10;

  // 🔍 Recherche
  const filteredData = data.filter((row) =>
    columns.some((col) =>
      String(row[col]).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // 🔼 Tri
  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];
    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // 📄 Pagination
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedData = sortedData.slice(startIndex, startIndex + rowsPerPage);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const checkValidated = (row, action) => {

    if (row?.statut !== "Validé")
      return true;

    const messages = {
      edit: {
        title: "Document validé",
        text: "Impossible de modifier un document validé.",
        icon: "warning"
      },
      delete: {
        title: "Document validé",
        text: "Impossible de supprimer un document validé.",
        icon: "warning"
      },
      validate: {
        title: "Déjà validé",
        text: "Ce document est déjà validé.",
        icon: "info"
      }
    };

    const msg = messages[action];

    Swal.fire(msg.title, msg.text, msg.icon);

    return false;
  };

  const role = (localStorage.getItem("role") || "").toLowerCase();
console.log("handleShowLivraisons :", handleShowLivraisons, "| livraison 1re ligne :", data[0]?.deliveryStatusLabel);
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title mb-0"><b>{title}</b></h3>
        <input
          type="text"
          className="form-control form-control-sm w-25"
          placeholder="Rechercher..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1); // Revenir à la première page après recherche
          }}
        />
      </div>

      <div className="card-body">
        <div className="table-responsive">

          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={index} onClick={() => requestSort(col)} style={{ cursor: "pointer" }} className="text-center">
                    {columnsMapping[col] || col}
                    {sortConfig.key === col && (sortConfig.direction === "asc" ? " 🔼" : " 🔽")}
                  </th>
                ))}
                {(handleEdit || openAssignModal || openHistory || exportReleve || handleDelete || handleExportWord || handleExportExcel || handleDetail || handleExport || handleExportPdf || handlePrintPdf || handleValidate || handleUnvalidate) && (
                  <th className="text-center">Actions</th>
                )}
              </tr>
            </thead>
            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan={columns.length + 1} className="text-center">Aucun résultat trouvé</td>
                </tr>
              ) : (
                paginatedData.map((row, rowIndex) => {
                  const uniqueKey = row[keyField] || `row-${rowIndex}`;
                  return (

                    <tr key={uniqueKey}>
                      {/* {columns.map((col) => (
                        <td key={col} className="text-center">{row[col]}</td>
                      ))} */}
                      {columns.map(col => (
                        <td key={col} className="text-center">

                          {col === "statut" ? (
                            <span
                              style={{
                                display: "inline-block",
                                width: "14px",
                                height: "14px",
                                borderRadius: "50%",
                                backgroundColor:
                                  row.statut === "Validé"
                                    ? "#28a745"
                                    : "#dc3545"
                              }}
                              title={row.statut}
                            />
                          ) : col === "paymentStatusLabel" ? (
                            <span
                              style={{
                                color:
                                  row.paymentStatusLabel === "Payé"
                                    ? "#28a745"
                                    : row.paymentStatusLabel === "Partiellement payé"
                                      ? "#ffc107"
                                      : "#dc3545",
                                fontWeight: "500"
                              }}
                            >
                              {row.paymentStatusLabel === "Payé"
                                ? "Payé"
                                : row.paymentStatusLabel === "Partiellement payé"
                                  ? "Partiellement payé"
                                  : row.paymentStatusLabel === "Non payé"
                                    ? "Non payé"
                                    : "-"}
                            </span>
                          )
                            : col === "deliveryStatusLabel" ?
                              (<span style={{
                                color: row.deliveryStatusLabel === "Livré" ? "#28a745" :
                                  row.deliveryStatusLabel === "Partiellement livré" ? "#ffc107" :
                                    row.deliveryStatusLabel === "Non livré" ? "#dc3545" : "#6c757d", fontWeight: "500"
                              }} >
                                {row.deliveryStatusLabel === "Livré" ? "Livré" : row.deliveryStatusLabel === "Partiellement livré" ?
                                  "Partiellement livré" : row.deliveryStatusLabel === "Non livré" ? "Non livré" : "-"} </span>) : (
                                row[col]
                              )}

                        </td>
                      ))}
                      {(handleEdit || openAssignModal || openHistory || exportReleve || handleDelete || handleExportWord || handleExportExcel || handleDetail || handleExport || handleExportPdf || handlePrintPdf || handleValidate || handleUnvalidate) && (
                        <td className="text-center">
                          {handleEdit && (
                            <button
                              className="btn btn-outline-primary"
                              title="Modifier"
                              onClick={() => {
                                if (!checkValidated(row, "edit")) return;
                                handleEdit(row);
                              }}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          )}
                          {
                            openAssignModal && (
                              <button
                                className="btn btn-outline-success"
                                title="Affecter des documents"
                                onClick={() => openAssignModal(row)}
                                style={{ marginLeft: "3px" }}
                              >
                                <i className="fas fa-link"></i>
                              </button>
                            )
                          }

                          {
                            openHistory && (
                              <button
                                className="btn btn-outline-info"
                                title="Voir l’historique des affectations"
                                onClick={() => openHistory(row)}
                                style={{ marginLeft: "3px" }}
                              >
                                <i className="fas fa-history"></i>
                              </button>
                            )
                          }
                          {/* {
                            exportReleve && (
                              <button
                                className="btn btn-outline-info"
                                title="Relevé de compte"
                                onClick={() => exportReleve(row)}
                                style={{ marginLeft: "3px" }}
                              >
                                <i className="fas fa-file-invoice-dollar"></i>
                              </button>
                            )
                          } */}
                          {handleShowReglements && row.paymentStatusLabel && row.paymentStatusLabel !== "Non payé" && (
                                <button className="btn btn-sm btn-success mr-1" title="Règlements"
                                        onClick={() => handleShowReglements(row)}>
                                    <i className="fas fa-money-bill-wave"></i>
                                </button>
                            )}
                            {handleShowLivraisons && row.deliveryStatusLabel && row.deliveryStatusLabel !== "Non livré" && (
                              <button
                                className="btn btn-outline-info"
                                title="Livraisons / Réceptions"
                                onClick={() => handleShowLivraisons(row)}
                                style={{ marginLeft: "3px" }}
                              >
                                <i className="fas fa-truck"></i>
                              </button>
                            )}
                          {handleExport && (<button
                            className="btn btn-outline-success"
                            title="Transférer"
                            onClick={() => handleExport(row)}
                            style={{ marginLeft: "3px" }}

                          >
                            <i className="fas fa-file-export"></i>
                          </button>)}
                          {handleExportPdf && (<button
                            className="btn btn-outline-secondary"
                            title="Exporter pdf"
                            onClick={() => handleExportPdf(row)}
                            style={{ marginLeft: "3px" }}

                          >
                            <i className="fas fa-file-pdf"></i>
                          </button>)}
                          {handlePrintPdf && (<button
                            className="btn btn-outline-print"
                            title="Imprimer"
                            onClick={() => handlePrintPdf(row)}
                            style={{ marginLeft: "3px" }}

                          >
                            <i className="fas fa-print"></i>
                          </button>)}
                          {handleValidate && row.statut !== "Validé" && (//role === "admin" && 
                            <button
                              className="btn btn-outline-success"
                              title="Valider"
                              onClick={() => {
                                if (!checkValidated(row, "validate")) return;
                                handleValidate(row.id);
                              }}
                              style={{ marginLeft: "3px" }}
                            >
                              <i className="fas fa-check"></i>
                            </button>
                          )}
                          {handleUnvalidate &&  row.statut === "Validé" && (//role === "admin" &&
                            <button
                              className="btn btn-outline-danger"
                              title="Devalider"
                              onClick={() => {
                                // if (!checkValidated(row, "validate")) return;
                                handleUnvalidate(row.id);
                              }}
                              style={{ marginLeft: "3px" }}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          )}
                          {handleDelete && (<button
                            className="btn btn-outline-danger"
                            title="Supprimer"
                            onClick={() => {
                              if (!checkValidated(row, "delete")) return;
                              handleDelete(row.id);
                            }}
                            style={{ marginLeft: "3px" }}

                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>)}

                          {handleExportWord && (
                            <button
                              className="btn btn-outline-secondary"
                              title="Imprimer"
                              onClick={() => handleExportWord(row[keyField])}
                              style={{ marginLeft: "3px" }}
                            >
                              <i className="fas fa-file-word me-1"></i>
                            </button>
                          )}
                          {handleExportExcel && (
                            <button
                              className="btn btn-outline-secondary"
                              title="Imprimer"
                              onClick={() => handleExportExcel(row[keyField])}
                              style={{ marginLeft: "3px" }}
                            >
                              <i className="fas fa-file-excel me-1"></i>
                            </button>
                          )}
                          {handleDetail && (
                            <button
                              className="btn btn-outline-info btn-sm"
                              title="Détails"
                              onClick={() => handleDetail(row)}
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                          )}

                        </td>
                      )}

                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">
          <div className="d-flex justify-content-center align-items-center flex-wrap gap-2 pagination-controls">
            Affichage de {Math.min(startIndex + 1, sortedData.length)} à{" "}
            {Math.min(startIndex + rowsPerPage, sortedData.length)} sur {sortedData.length} éléments
          </div>
          <div className="d-flex justify-content-center align-items-center flex-wrap gap-2">
            <button
              className="btn btn-secondary btn-sm"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              Précédent
            </button>
            <span className="mx-2">Page {currentPage} / {Math.max(totalPages, 1)}</span>
            <button
              className="btn btn-secondary btn-sm"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              Suivant
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default DataTableComponent;
